import React from "react";
import styles from "../../styles";
import FileExplorerGUI from "../../components/FileExplorerGUI";
import WindowedFileExplorer from "../../components/WindowedFileExplorer";
import SysAppExplorerGUI from "../../components/SysAppExplorerGUI";
import IDE from "../../components/IDE";
import InstallModal from "../../components/InstallModal";
import MenuBar from "../../components/MenuBar";
import AppExplorerGUI from "../../components/AppExplorerGUI";
import FileEditor from "../../components/FileEditor";
import MediaView from "../../components/MediaView";
import AppView from "../../components/AppView";
import Window from "../../components/Window";
import ConsoleEditor from "../../components/ConsoleEditor";
import { themeColors } from "../../config.js";
import Night from "../../background/Night.jpg";
import Lake from "../../background/Lake.jpg";
import Town from "../../background/Town.jpg";
import Boat from "../../background/Boat.jpg";
import { UUID } from "../../utils";

class Desktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      codeEditorRoot: null,
      width: window.innerWidth,
      height: window.innerHeight,
      fileExplorers: [],
      currentWindows: [],
      currentFiles: [],
      currentRaw: [],
      currentApps: [],
      currentConsoles: [],
      installHash: "",
      appExplorerOn: false,
      backgroundIndex: 0,
    };
    this.backgrounds = [Night, Lake, Town, Boat];
    this.setCodeEditorRoot = this.setCodeEditorRoot.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.openWindow = this.openWindow.bind(this);
    this.closeWindow = this.closeWindow.bind(this);
    this.setInstallHash = this.setInstallHash.bind(this);
    this.toggleAppExplorer = this.toggleAppExplorer.bind(this);
    this.executeAppMessage = this.executeAppMessage.bind(this);
    this.focusCurrentFile = this.focusCurrentFile.bind(this);
    this.focusCurrentWindow = this.focusCurrentWindow.bind(this);
    this.focusCurrentExplorer = this.focusCurrentExplorer.bind(this);
    this.focusCurrentRaw = this.focusCurrentRaw.bind(this);
    this.focusCurrentApp = this.focusCurrentApp.bind(this);
    this.focusCurrentConsole = this.focusCurrentConsole.bind(this);
    this.addCurrentFile = this.addCurrentFile.bind(this);
    this.addCurrentWindow = this.addCurrentWindow.bind(this);
    this.addCurrentApp = this.addCurrentApp.bind(this);
    this.addCurrentRaw = this.addCurrentRaw.bind(this);
    this.addCurrentConsole = this.addCurrentConsole.bind(this);
    this.closeCurrentRaw = this.closeCurrentRaw.bind(this);
    this.closeCurrentApp = this.closeCurrentApp.bind(this);
    this.closeCurrentFile = this.closeCurrentFile.bind(this);
    this.closeCurrentWindow = this.closeCurrentWindow.bind(this);
    this.closeCurrentConsole = this.closeCurrentConsole.bind(this);
    this.saveCurrentFile = this.saveCurrentFile.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
  }

  componentDidMount() {
    const systemData = this.props.systemData;
    window.addEventListener("resize", this.updateDimensions);
    if (systemData.rollingBackground) {
      this.timer = setInterval(
        () =>
          this.props.updateSystemData({
            backgroundIndex:
              systemData.backgroundIndex === this.backgrounds.length - 1
                ? 0
                : systemData.backgroundIndex + 1,
          }),
        systemData.rollingInterval ? systemData.rollingInterval * 1000 : 30000
      );
    } else {
      this.setState((state) => ({
        ...state,
        backgroundIndex: systemData.backgroundIndex
          ? systemData.backgroundIndex
          : 0,
      }));
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate(prevProps) {
    const systemData = this.props.systemData;
    if (systemData.backgroundIndex !== prevProps.systemData.backgroundIndex) {
      this.setState((state) => ({
        ...state,
        backgroundIndex: systemData.backgroundIndex
          ? systemData.backgroundIndex
          : 0,
      }));
      clearInterval(this.timer);
      if (systemData.rollingBackground) {
        this.timer = setInterval(
          () =>
            this.props.updateSystemData({
              backgroundIndex:
                systemData.backgroundIndex === this.backgrounds.length - 1
                  ? 0
                  : systemData.backgroundIndex + 1,
            }),
          systemData.rollingInterval ? systemData.rollingInterval * 1000 : 30000
        );
      }
    }
    if (
      systemData.rollingBackground !== prevProps.systemData.rollingBackground ||
      systemData.rollingInterval !== prevProps.systemData.rollingInterval
    ) {
      clearInterval(this.timer);
      if (systemData.rollingBackground) {
        this.timer = setInterval(
          () =>
            this.props.updateSystemData({
              backgroundIndex:
                systemData.backgroundIndex === this.backgrounds.length - 1
                  ? 0
                  : systemData.backgroundIndex + 1,
            }),
          systemData.rollingInterval ? systemData.rollingInterval * 1000 : 30000
        );
      }
    }
  }

  updateDimensions() {
    this.setState((state) => ({
      ...state,
      width: window.innerWidth,
      height: window.innerHeight,
    }));
  }

  setInstallHash(hash) {
    this.setState((state) => ({
      ...state,
      installHash: hash,
    }));
  }

  setCodeEditorRoot(hash) {
    this.setState((state) => ({
      ...state,
      codeEditorRoot: hash,
    }));
  }

  closeWindow(index) {
    const windows = this.state.fileExplorers;
    windows.splice(index, 1);
    this.setState((state) => ({
      ...state,
      fileExplorers: windows,
    }));
  }

  openWindow(root) {
    const windows = this.state.fileExplorers;
    windows.push(root);
    this.setState((state) => ({
      ...state,
      fileExplorers: windows,
    }));
  }

  toggleAppExplorer() {
    this.setState((state) => ({
      ...state,
      appExplorerOn: !state.appExplorerOn,
    }));
  }

  executeAppMessage(hash, message) {
    const fileSystem = this.props.fileSystem;
    const frame = document.getElementById(hash + "_appView");
    if (message.type === "exec") {
      console.log("EXEC", hash, message.command);
    } else if (message.type === "post") {
      console.log("POST", hash, message.key, message.value);
      fileSystem.setAppStorage(hash, message.key, message.value);
    } else if (message.type === "get") {
      console.log("GET", hash, message.key);
      const value = fileSystem.getAppStorage(hash, message.key);
      frame.contentWindow.postMessage({ ...message, response: value });
      console.log(value);
    }
  }

  addCurrentFile(hash) {
    for (let entry of this.state.currentFiles) {
      if (entry.metadata.hash === hash) return;
    }
    const file = this.props.fileSystem.getFile(hash);
    this.setState((state) => ({
      ...state,
      currentFiles: [
        ...state.currentFiles,
        { metadata: file.getMetaData(), value: file.getData(), saved: true },
      ],
    }));
  }

  addCurrentWindow(hash) {
    for (let entry of this.state.currentWindows) {
      if (entry.metadata.hash === hash) return;
    }
    const file = this.props.fileSystem.getFile(hash);
    this.setState((state) => ({
      ...state,
      currentWindows: [
        ...state.currentWindows,
        { metadata: file.getMetaData(), value: file.getData(), saved: true },
      ],
    }));
  }

  addCurrentConsole(hash) {
    const uid = UUID();
    this.setState((state) => ({
      ...state,
      currentConsoles: [...state.currentConsoles, { hash, uid }],
    }));
  }

  onChangeText(e, index) {
    const text = e.target.innerText;
    const currentFiles = this.state.currentFiles;
    currentFiles[index].value = text;
    currentFiles[index].saved = false;
    this.setState((state) => ({
      ...state,
      currentFiles: currentFiles,
      popUpOn: false,
    }));
  }

  saveCurrentFile(index) {
    const currentFiles = this.state.currentFiles;
    currentFiles[index].saved = true;

    this.props.fileSystem.saveFile(
      currentFiles[index].metadata.hash,
      currentFiles[index].value
    );
    this.setState((state) => ({
      ...state,
      currentFiles,
    }));
  }

  closeCurrentFile(index) {
    const currentFiles = this.state.currentFiles;
    if (!currentFiles[index].saved) {
      const noSave = window.confirm(
        "Do you want to close without saving your modifications? ('Ctrl + S' to save)"
      );
      if (noSave) {
        currentFiles.splice(index, 1);
        this.setState((state) => ({
          ...state,
          currentFiles,
        }));
      }
    } else {
      currentFiles.splice(index, 1);
      this.setState((state) => ({
        ...state,
        currentFiles,
      }));
    }
  }

  closeCurrentConsole(index) {
    const currentConsoles = this.state.currentConsoles;
    currentConsoles.splice(index, 1);
    this.setState((state) => ({
      ...state,
      currentConsoles,
    }));
  }

  focusCurrentWindow(index) {
    const currentWindows = this.state.currentWindows;
    const currentWindow = currentWindows.splice(index, 1);
    currentWindows.push(...currentWindow);
    this.setState((state) => ({
      ...state,
      currentWindows,
    }));
  }

  focusCurrentFile(index) {
    const currentFiles = this.state.currentFiles;
    const currentFile = currentFiles.splice(index, 1);
    currentFiles.push(...currentFile);
    this.setState((state) => ({
      ...state,
      currentFiles,
    }));
  }

  focusCurrentRaw(index) {
    const currentRaw = this.state.currentRaw;
    const currentR = currentRaw.splice(index, 1);
    currentRaw.push(...currentR);
    this.setState((state) => ({
      ...state,
      currentRaw,
    }));
  }

  focusCurrentApp(index) {
    const currentApps = this.state.currentApps;
    const currentApp = currentApps.splice(index, 1);
    currentApps.push(...currentApp);
    this.setState((state) => ({
      ...state,
      currentApps,
    }));
  }

  focusCurrentExplorer(index) {
    const fileExplorers = this.state.fileExplorers;
    const fileExplorer = fileExplorers.splice(index, 1);
    fileExplorers.push(...fileExplorer);
    this.setState((state) => ({
      ...state,
      fileExplorers,
    }));
  }

  focusCurrentConsole(index) {
    const currentConsoles = this.state.currentConsoles;
    const currentConsole = currentConsoles.splice(index, 1);
    currentConsoles.push(...currentConsole);
    this.setState((state) => ({
      ...state,
      currentConsoles,
    }));
  }

  closeCurrentWindow(index) {
    const currentWindows = this.state.currentWindows;
    if (!currentWindows[index].saved) {
      const noSave = window.confirm(
        "Do you want to close without saving your modifications? ('Ctrl + S' to save)"
      );
      if (noSave) {
        currentWindows.splice(index, 1);
        this.setState((state) => ({
          ...state,
          currentWindows,
        }));
      }
    } else {
      currentWindows.splice(index, 1);
      this.setState((state) => ({
        ...state,
        currentWindows,
      }));
    }
  }

  addCurrentRaw(hash) {
    for (let entry of this.state.currentRaw) {
      if (entry.metadata.hash === hash) return;
    }
    const app = this.props.fileSystem.getApp(hash);
    this.setState((state) => ({
      ...state,
      currentRaw: [
        ...state.currentRaw,
        { metadata: app.getMetaData(), value: app.getData(), saved: true },
      ],
    }));
  }

  addCurrentApp(app) {
    const currentApps = this.state.currentApps;
    currentApps.push(app);
    this.setState((state) => ({
      ...state,
      currentApps,
    }));
  }

  closeCurrentApp(index) {
    const currentApps = this.state.currentApps;
    currentApps.splice(index, 1);
    this.setState((state) => ({
      ...state,
      currentApps,
    }));
  }

  closeCurrentRaw(index) {
    const currentRaw = this.state.currentRaw;
    if (!currentRaw[index].saved) {
      const noSave = window.confirm(
        "Do you want to close without saving your modifications? ('Ctrl + S' to save)"
      );
      if (noSave) {
        currentRaw.splice(index, 1);
        this.setState((state) => ({
          ...state,
          currentRaw,
        }));
      }
    } else {
      currentRaw.splice(index, 1);
      this.setState((state) => ({
        ...state,
        currentRaw,
      }));
    }
  }

  render() {
    const fileSystem = this.props.fileSystem;
    const systemAPI = this.props.systemAPI;
    const fileExplorerWindows = this.state.fileExplorers.map((root, index) => (
      <WindowedFileExplorer
        key={root}
        fileSystem={this.props.fileSystem}
        setCodeEditorRoot={this.setCodeEditorRoot}
        setInstallHash={this.setInstallHash}
        addCurrentFile={this.addCurrentFile}
        addCurrentWindow={this.addCurrentWindow}
        closeCurrentWindow={this.closeCurrentWindow}
        closeCurrentFile={this.closeCurrentFile}
        saveCurrentFile={this.saveCurrentFile}
        root={root}
        id={root}
        onFocus={() => this.focusCurrentExplorer(index)}
        name={fileSystem.getDirectory(root).getName()}
        closeWindow={() => this.closeWindow(index)}
        openWindow={this.openWindow}
        systemData={this.props.systemData}
      />
    ));
    const rawWindows = this.state.currentRaw.map((entry, index) => (
      <FileEditor
        key={entry.metadata.hash}
        id={entry.metadata.hash}
        config={{
          frameColor: themeColors.backgroundTheme,
          textColor: themeColors.foregroundTheme,
          lineHeight: "20px",
          fontFamily: "roboto",
          fontSize: 15,
        }}
        onFocus={() => this.focusCurrentRaw(index)}
        name={entry.metadata.name}
        value={entry.value}
        saved={entry.saved}
        closeWindow={() => this.closeCurrentRaw(index)}
        height={"100%"}
        width={"100%"}
      />
    ));
    const fileWindows = this.state.currentFiles.map((entry, index) => (
      <FileEditor
        key={entry.metadata.hash}
        id={entry.metadata.hash}
        config={{
          frameColor: themeColors.backgroundTheme,
          textColor: themeColors.foregroundTheme,
          lineHeight: "20px",
          fontFamily: "roboto",
          fontSize: 15,
        }}
        name={entry.metadata.name}
        value={entry.value}
        saved={entry.saved}
        onChangeText={(e) => this.onChangeText(e, index)}
        closeWindow={() => this.closeCurrentFile(index)}
        onFocus={() => this.focusCurrentFile(index)}
        saveFile={() => this.saveCurrentFile(index)}
        editable={true}
        height={"100%"}
        width={"100%"}
      />
    ));
    const mediaWindows = this.state.currentWindows.map((entry, index) => (
      <MediaView
        key={entry.metadata.hash}
        name={entry.metadata.name}
        hash={entry.metadata.hash}
        data={entry.value}
        onFocus={() => this.focusCurrentWindow(index)}
        closeWindow={() => this.closeCurrentWindow(index)}
      />
    ));
    const appWindows = this.state.currentApps.map((entry, index) => (
      <AppView
        key={entry.getHash()}
        app={entry}
        id={entry.getHash() + "_appView"}
        closeWindow={() => this.closeCurrentApp(index)}
        onFocus={() => this.focusCurrentApp(index)}
        handleAppMessage={(msg) =>
          this.executeAppMessage(entry.getHash(), msg.data)
        }
      />
    ));
    const consoleWindows = this.state.currentConsoles.map((entry, index) => (
      <Window
        id={"console_window"}
        key={entry.uid}
        top={0}
        left={0}
        name={"console"}
        onClick={() => this.focusCurrentConsole(index)}
        onCancel={() => this.closeCurrentConsole(index)}
      >
        <ConsoleEditor
          width={"100%"}
          height={"100%"}
          lines={[{ value: "" }]}
          fileSystem={this.props.fileSystem}
          evalFunc={this.props.systemAPI.executeCommand}
        />
      </Window>
    ));

    return (
      <div
        className="desktop"
        style={{
          ...styles.fullScreenContainer,
          ...styles.column,
          backgroundColor: themeColors.backgroundTheme,
          backgroundSize: "cover",
          backgroundImage: `url(${
            this.backgrounds[this.state.backgroundIndex]
          })`,
        }}
      >
        <MenuBar
          disconnect={this.props.signOutUser}
          userInfo={this.props.userInfo}
          updateUserInfo={this.props.updateUserInfo}
        />
        <FileExplorerGUI
          fileSystem={fileSystem}
          localMode={this.props.localMode}
          setCodeEditorRoot={this.setCodeEditorRoot}
          setInstallHash={this.setInstallHash}
          root={"root"}
          dims={{ width: this.state.width, height: this.state.height }}
          openWindow={this.openWindow}
          addCurrentFile={this.addCurrentFile}
          addCurrentWindow={this.addCurrentWindow}
          addCurrentConsole={this.addCurrentConsole}
          closeCurrentWindow={this.closeCurrentWindow}
          closeCurrentFile={this.closeCurrentFile}
          saveCurrentFile={this.saveCurrentFile}
          systemData={this.props.systemData}
        />
        <SysAppExplorerGUI
          dims={{ width: this.state.width, height: this.state.height }}
          fileSystem={fileSystem}
          systemData={this.props.systemData}
          updateSystemData={this.props.updateSystemData}
          backgrounds={this.backgrounds}
          userInfo={this.props.userInfo}
          localMode={this.props.localMode}
          appFuncs={{
            toggleAppExplorer: this.toggleAppExplorer,
          }}
        />
        {fileExplorerWindows}
        {fileWindows}
        {mediaWindows}
        {rawWindows}
        {appWindows}
        {consoleWindows}
        {this.state.installHash !== "" && (
          <InstallModal
            userId={this.props.userId}
            hash={this.state.installHash}
            localMode={this.props.localMode}
            name={"App Installer"}
            fileSystem={this.props.fileSystem}
            handleInstallApp={this.props.handleInstallApp}
            closeInstaller={() => this.setInstallHash("")}
          />
        )}
        {this.state.codeEditorRoot && (
          <IDE
            systemAPI={systemAPI}
            fileSystem={fileSystem}
            currentHash={this.state.codeEditorRoot}
            closeWindow={() => this.setCodeEditorRoot(null)}
            executeAppMessage={this.executeAppMessage}
          />
        )}
        <AppExplorerGUI
          explorerOn={this.state.appExplorerOn}
          dims={{ width: this.state.width, height: this.state.height }}
          fileSystem={fileSystem}
          toggleAppExplorer={this.toggleAppExplorer}
          addCurrentApp={this.addCurrentApp}
          addCurrentRaw={this.addCurrentRaw}
          closeCurrentApp={this.closeCurrentApp}
          closeCurrentRaw={this.closeCurrentRaw}
          systemData={this.props.systemData}
        />
      </div>
    );
  }
}

export default Desktop;
